<div class="consent-management">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'pages.settings.consents.loading' | transloco }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error-container">
    <div class="error-message">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ error }}</span>
      <button type="button" class="dismiss-btn" (click)="dismissError()" aria-label="Dismiss error">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <!-- Consent Management Content -->
  <div *ngIf="!loading" class="consent-content">
    <!-- Page Description -->
    <div class="page-intro">
      <h2>{{ 'pages.settings.consents.title' | transloco }}</h2>
      <p>{{ 'pages.settings.consents.description' | transloco }}</p>
    </div>

    <!-- Essential Consents -->
    <div class="consent-section" *ngIf="getEssentialConsents().length > 0">
      <div class="category-header">
        <h3>{{ 'pages.settings.consents.categories.essential' | transloco }}</h3>
        <p>{{ 'pages.settings.consents.categories.essentialDescription' | transloco }}</p>
      </div>
      <div class="consent-items">
        <app-card *ngFor="let consent of getEssentialConsents()" class="consent-card required">
          <div class="consent-card-content">
            <div class="consent-info">
              <h4>{{ consent.consentType | transloco }}</h4>
              <p>{{ 'descriptions.' + consent.consentType | transloco }}</p>
              <div class="consent-meta">
                <span *ngIf="consent.grantedAt" class="granted-date">
                  {{ 'pages.settings.consents.grantedOn' | transloco }}: {{ formatDate(consent.grantedAt) }}
                </span>
                <span *ngIf="consent.version" class="version">{{ 'pages.settings.consents.version' | transloco }}: {{ consent.version }}</span>
              </div>
            </div>
            <div class="consent-control">
              <div class="required-consent">
                <input type="checkbox" [checked]="consent.granted" [disabled]="true" class="consent-checkbox" />
                <span class="required-label">{{ 'pages.settings.consents.required' | transloco }}</span>
              </div>
            </div>
          </div>
        </app-card>
      </div>
    </div>

    <!-- Optional Consents -->
    <div class="consent-section" *ngIf="getOptionalConsents().length > 0">
      <div class="category-header">
        <h3>{{ 'pages.settings.consents.categories.optional' | transloco }}</h3>
        <p>{{ 'pages.settings.consents.categories.optionalDescription' | transloco }}</p>
      </div>
      <div class="consent-items">
        <app-card *ngFor="let consent of getOptionalConsents()" class="consent-card" [ngClass]="{ updating: isUpdating(consent.consentType) }">
          <div class="consent-card-content">
            <div class="consent-info">
              <h4>{{ consent.consentType | transloco }}</h4>
              <p>{{ 'descriptions.' + consent.consentType | transloco }}</p>
              <div class="consent-meta">
                <span *ngIf="consent.grantedAt" class="granted-date">
                  {{ 'pages.settings.consents.grantedOn' | transloco }}: {{ formatDate(consent.grantedAt) }}
                </span>
                <span *ngIf="consent.withdrawnAt" class="withdrawn-date">
                  {{ 'pages.settings.consents.withdrawnOn' | transloco }}: {{ formatDate(consent.withdrawnAt) }}
                </span>
                <span *ngIf="consent.version" class="version">{{ 'pages.settings.consents.version' | transloco }}: {{ consent.version }}</span>
              </div>
            </div>
            <div class="consent-control">
              <div class="toggle-container">
                <input
                  type="checkbox"
                  [checked]="consent.granted"
                  [disabled]="isUpdating(consent.consentType)"
                  (change)="onConsentToggle(consent.consentType, !consent.granted)"
                  class="consent-checkbox" />
                <mat-spinner *ngIf="isUpdating(consent.consentType)" diameter="20" class="update-spinner"></mat-spinner>
              </div>
            </div>
          </div>
        </app-card>
      </div>
    </div>

    <!-- Footer Info -->
    <div class="consent-footer">
      <div class="info-notice">
        <i class="fas fa-info-circle"></i>
        <p>
          {{ 'pages.settings.consents.footerInfo' | transloco }}
          <a class="checkbox-link" [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'privacy-policy']" target="_blank">
            {{ 'auth.register.privacyPolicy1' | transloco }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
